export default "__VITE_ASSET__bL9iohlT__"